import React from 'react';
import Aerolineas from '../assets/logoAerolineas.svg';
// import Flybondi from '../assets/logoFlybondi.svg';
import Jetsmart from '../assets/logoJetsmart.svg';
import Latam from '../assets/logoLatam.png';
import Iberia from '../assets/logoIberia.png';
import Arajet from '../assets/logoArajet.png';
import Gol from '../assets/logoGol.png';

function AirlinesSection() {
  const airlines = [
    { name: 'Aerolíneas Argentinas', logo: Aerolineas },
    { name: 'JetSMART', logo: Jetsmart },
    { name: 'LATAM', logo: Latam },
    { name: 'Iberia', logo: Iberia },
    { name: 'Arajet', logo: Arajet },
    { name: 'GOL', logo: Gol },
    // { name: 'Flybondi', logo: Flybondi },
  ];

  return (
    <section className="bg-white py-8 md:py-12">
      <div className="container mx-auto px-4">
        <h2 className="text-lg md:text-2xl font-bold font-montserrat text-[#001b56] text-center mb-6 md:mb-12">
          TRABAJAMOS CON LAS MEJORES AEROLÍNEAS
        </h2>
        <div className="flex justify-center items-center gap-6 md:gap-10 flex-wrap">
          {airlines.map((airline, index) => (
            <div key={index} className="text-center opacity-70 hover:opacity-100 transition-opacity duration-300">
              <img
                src={airline.logo}
                alt={airline.name}
                className="w-20 md:w-32 h-auto object-contain"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default AirlinesSection;
